export default __webpack_public_path__ + "static/media/checkers-8-lqMAX.b37da685.jpg";